import React from "react";
import {reduxWrapper} from "../globalState";
import {Button, Image, RelativeSwitch, SortedTable} from "../components/common/common";
import {Route} from "react-router-dom";
import {DropDown, FormInput, FormText, ImageUpload, ValidateForm} from "../components/common/formValidation";
import {EditorState} from "draft-js";
import {getImage} from "../lib/api";
import {formatTime, isEmpty, mapObjectName, mapObjectToArray, relativePath, saveMessage} from "../lib/tools";


const ArticleTool = () => (
	<RelativeSwitch>
		<Route path=":id" render={({match: {params: {id}}}) => <ArticleToolEdit id={id}/>}/>
		<Route component={ArticleToolOverview}/>
	</RelativeSwitch>
);


class ArticleToolEditRender extends React.Component {
	
	state = {
		article: {
			title: null,
			content: EditorState.createEmpty(),
			identifier: null,
			image: null
		}
	};
	
	constructor(props) {
		super(props);
		this.submit = ({editor}) => {
		
		}
	}
	
	save(article) {
		if (this.state.article.id) {
			this.props.apiCall(
				"PUT", `/article/${this.state.article.id}`,
				() => this.props.sendMessage(saveMessage()),
				article
			);
		} else {
			this.props.apiCall("POST", `/articles`, () => {
				this.props.sendMessage(saveMessage());
				this.props.history.replace(relativePath(`../${article.identifier}`));
			}, article);
		}
	}
	
	componentWillMount() {
		if (this.props.id !== "new") {
			this.props.apiCall(
				"GET", `/article`,
				article => this.setState({article}),
				{identifier: this.props.id}
			);
		}
	}
	
	render() {
		
		const subsections = mapObjectToArray(this.props.sections, x => x.children).flat();
		
		return (
			<div id="articleTool">
				<ValidateForm values={this.state.article} onChange={article => this.setState({article})}
				              onSubmit={val => this.save(val)}>
					<FormInput name="title" className="title" req/>
					<FormText name="content" innerClass="articleBody"/>
					{this.props.id !== "new" &&
					<Button to={`/inspiration/${this.state.article.identifier}`} blank>Se live</Button>}
					<br/>
					<FormInput name="identifier" req locked={this.props.id !== "new"}/>
					<br/>
					<br/>
					<DropDown options={mapObjectName(subsections, "title")} name="sectionId" title="Section"
					          externalLabel/>
					<h3>Thumbnail</h3>
					<ImageUpload name="image"/>
					<Button className="floatingBtn" submit>Save</Button>
				</ValidateForm>
			</div>
		);
	}
}

const ArticleToolEdit = reduxWrapper("getApiCall", "getSendMessage", "loadSections")(ArticleToolEditRender);

class ArticleToolOverviewRender extends React.Component {
	
	state = {
		articles: [],
		loading: false,
		order: "id",
		orderAsc: true,
		page: 0
	};
	
	timeout;
	
	loadArticles() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({loading: true});
			this.props.apiCall("GET", "/articles", articles => this.setState({articles, loading: false}), {
				simple: true,
				limit: 20,
				orderBy: this.state.order,
				orderAsc: this.state.orderAsc,
				limitOffset: this.state.page * 20
			});
		}, 1000);
	}
	
	componentWillMount() {
		this.loadArticles();
	}
	
	onTableChange(changes) {
		this.setState(changes);
		this.loadArticles();
	}
	
	columns = {
		id: {
			name: "ID",
			sortable: true
		},
		image: {
			name: "Thumbnail",
			render: val => <Image src={getImage(val, true)}/>
		},
		title: {
			name: "Title",
			sortable: true
		},
		sectionId: {
			name: "Section",
			sortable: true,
			render: val => this.props.sections[val].title
		},
		created: {
			name: "Created",
			sortable: true,
			render: formatTime
		},
		updated: {
			name: "Updated",
			sortable: true,
			render: formatTime
		}
	};
	
	render() {
		const {sections, history} = this.props;
		return (
			<div>
				<Button to={relativePath("/new")}>New article</Button>
				<SortedTable
					columns={this.columns}
					rows={this.state.articles}
					loading={isEmpty(sections) || this.state.loading}
					redirect={relativePath("") + "/"}
					redirectProp="identifier"
					onChange={val => this.onTableChange(val)}
					values={this.state}
					history={history}/>
			</div>
		);
	}
}

const ArticleToolOverview = reduxWrapper("getApiCall", "loadSections")(ArticleToolOverviewRender);


export default ArticleTool;


// WEBPACK FOOTER //
// ./src/admin/articleTool.js